
export default {
  download: 'Скачивать',
}
